import { t } from "i18next";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useFetch } from "../../../../../hooks/useFetch";
import { AdminSensorType, DowntimesType } from "../../../../../types/types";
import { ScrollArea } from "../../../../../ui/ScrollArea/ScrollArea";
import { Separator } from "../../../../../ui/Separator";
import { Button } from "../../../../../ui/Button";
import { Input } from "../../../../../ui/Input/Input";
import { useOutletContext } from "react-router-dom";
import DeleteSensor from "../../DeleteDowntime";
import DeleteDowntime from "../../DeleteDowntime";

type Props = {
  id: string | undefined;
  currentDowntime: DowntimesType | undefined;
};

const DowntimeSettingsTab = ({ id, currentDowntime }: Props) => {
  //const [errors, setErrors] = useState([]);
  const [sensors, setSensors] =
    useOutletContext<[AdminSensorType[], Function]>();

  let [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const { handleSubmit, reset, control } = useForm({
    defaultValues: {
      name: currentDowntime?.name,
      description: currentDowntime?.description,
    },
  });

  function openDeleteModal() {
    setIsDeleteOpen(true);
  }

  function closeDeleteModal() {
    setIsDeleteOpen(false);
  }

  // Обновление информации о сенсоре
  const [
    { response: saveResponse, isLoading: saveIsLoading, error: saveError },
    doFetchItemSave,
  ] = useFetch(`/administration/directories/downtime_reasons/${id}`, true);

  const onSubmit = (formData: any) => {
    doFetchItemSave({
      method: "PUT",
      data: {
        data: {
          name: formData.name,
          description: formData.description,
        },
      },
    });
  };

  const editSensor = (itemSaveResponse: { data: unknown }) => {
    const newDowntimeData = itemSaveResponse.data as unknown as DowntimesType;
    const withoutCurrentItem = sensors?.filter(
      (sensor) => sensor.id != currentDowntime?.id,
    )!;
    setSensors(
      [...withoutCurrentItem, newDowntimeData].sort(
        (a, b) => Number(a.id) - Number(b.id),
      ),
    );
  };

  useEffect(() => {
    if (!saveResponse) return;
    editSensor(saveResponse);
  }, [saveResponse]);

  return (
    <>
      <div className="pt-8">
        <form onSubmit={handleSubmit(onSubmit)}>
          <ScrollArea>
            <div className="flex flex-col gap-3">
              <Controller
                name="name"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div className="relative space-y-2">
                    <Input {...field} label={`${t("name")}*`} />
                  </div>
                )}
              />
              <Controller
                name="description"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div className="relative space-y-2">
                    <Input {...field} label={`${t("description")}*`} />
                  </div>
                )}
              />

              <Separator />
              <div className="mt-8 flex w-full justify-between">
                <Button
                  variant={"destructive"}
                  size={"sm"}
                  type="button"
                  onClick={() => openDeleteModal()}
                >
                  {t("delete")}
                </Button>
                <Button variant={"default"} size={"sm"} type="submit">
                  {t("save")}
                </Button>
              </div>
            </div>
          </ScrollArea>
        </form>
      </div>
      <DeleteDowntime
        id={id!}
        isDeleteOpen={isDeleteOpen}
        closeModal={closeDeleteModal}
      />
    </>
  );
};

export default DowntimeSettingsTab;
